import { useMemo } from "react";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import CategoryStrip from "./components/CategoryStrip";
import LatestUpdates from "./components/LatestUpdates";
import SerialList from "./components/SerialList";
import NewsFeed from "./components/NewsFeed";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

const faqs = [
  {
    q: "日漫情报站多久更新一次最新话？",
    a: "我们会在各大连载作品官方发布更新后的第一时间同步内容，通常每天都会有多部人气作品的最新话情报与解读上线，确保你不错过任何一话。",
  },
  {
    q: "剧透专区的内容会损坏我的追更体验吗？",
    a: "情报剧透专区的内容均带有明确的「剧透预警」提示，并默认折叠。如果你不希望被提前剧透，可以跳过该分类，仅浏览最新话与连载更新版块。",
  },
  {
    q: "休刊提醒是怎么来的？",
    a: "休刊公告分类会汇总各大作品官方发布的休刊与复刊安排，并标注预计的恢复连载时间，帮助你合理安排追更节奏。",
  },
];

export default function Home() {
  const jsonLd = useMemo(() => {
    return [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "日漫情报站",
        url: "https://animesync.github.io/",
        logo: "https://animesync.github.io/logo.png",
        description: "日漫最新话、日漫连载、日漫更新、日漫情报、日漫剧透、日漫休刊提醒资讯站",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "日漫情报站",
        url: "https://animesync.github.io/",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "日漫情报站 - 日漫最新话·日漫更新·日漫连载剧透休刊一手抢先看",
        url: "https://animesync.github.io/",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ];
  }, []);

  return (
    <>
      <Seo
        title="日漫情报站 - 日漫最新话·日漫更新·日漫连载剧透休刊一手抢先看"
        description="日漫情报站汇总日漫最新话、日漫连载进度，日漫更新快人一步，还有日漫情报、日漫剧透、日漫休刊提醒，让你第一时间掌握追更动态，不再错过任何一话。"
        keywords="日漫,日漫最新话,日漫连载,日漫更新,日漫情报,日漫剧透,日漫休刊"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <CategoryStrip />
      <LatestUpdates />
      <SerialList />
      <NewsFeed />
      <FaqSection />
      <CtaBanner />
    </>
  );
}